import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import BarChart from '../charts/barChart';

interface WaiverMatchesByAirlineProps {
  waivers: {
    yearMonths: string[];
    airlines: string[];
    [key: string]: any;
  };
  tripMatches: {
    yearMonths: string[];
    [key: string]: any;
  };
}

interface ChartData {
  title: string;
  categories: string[];
  series: {
    name: string;
    data: number[];
    altData: number[];
  }[];
}

const WaiverMatchesByAirline: React.FC<WaiverMatchesByAirlineProps> = ({ waivers, tripMatches }) => {
  const [chartData, setChartData] = useState<ChartData | null>(null);

  useEffect(() => {
    const buildAirlineTripMatchData = (tripMatches: any, yearMonths: string[], airline: string): number[] => {
      return _(yearMonths)
        .map(yearMonth => tripMatches.yearMonths.indexOf(yearMonth))
        .map(yearMonthIndex =>
          tripMatches[airline] && yearMonthIndex >= 0
            ? tripMatches[airline][yearMonthIndex]
            : 0,
        )
        .value();
    };

    const buildChartData = (): ChartData => {
      return {
        title: 'Waivers & Trip Matches by Airline',
        categories: waivers.yearMonths,
        series: _.map(waivers.airlines, airline => ({
          name: airline,
          data: waivers[airline],
          altData: buildAirlineTripMatchData(
            tripMatches,
            waivers.yearMonths,
            airline,
          ),
        })),
      };
    };

    setChartData(buildChartData());
  }, [waivers, tripMatches]);

  const toolTipLabeller = (airline: string, waiverCount: number, tripMatchCount: number): string => {
    const waivers = waiverCount === 1 ? 'waiver' : 'waivers';
    const matches = tripMatchCount === 1 ? 'trip match' : 'trip matches';
    return `${airline}: ${waiverCount} ${waivers}, ${tripMatchCount} ${matches}`;
  };

  return (
    <div className="row">
      <div className="col-lg-1"></div>
      <div className="col-lg-10 data-point">
        {chartData && (
          <BarChart
            reportData={chartData}
            toolTipLabelFunction={toolTipLabeller}
            minWidth={650}
            height={360+(chartData.series.length*22.5)}
            bottomMargin={chartData.series.length*22.5}
          />
        )}
      </div>
      <div className="col-lg-1"></div>
    </div>
  );
};

export default WaiverMatchesByAirline;